var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"mode":"out-in","css":false},on:{"enter":_vm.slideDown,"leave":_vm.slideUp}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }